import { AxiosError } from 'axios'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, context) => {
    if (error instanceof AxiosError) {
      const resp = error.response
      showError({ statusCode: resp?.status || 500, message: resp?.statusText })
    } else if (error instanceof Error) {
      console.error(error)
      // sendException(error);
      showError(error)
    } else {
      showError({ statusCode: 500 })
    }
  }
})
